module.exports = __webpack_public_path__ + "static/img/1.d2090e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/4/1.png
// module id = lwA9
// module chunks = 0